import UrlHelper from 'common/helpers/url'

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark'
}

export default class ThemeHelper {
  static getThemeColor = (search: string): Theme => {
    const themeParams = UrlHelper.getQueryParam(search, 'theme')

    return themeParams === Theme.DARK ? Theme.DARK : Theme.LIGHT
  }

  static isDarkMode = (search: string) => {
    return ThemeHelper.getThemeColor(search) === Theme.DARK
  }
}
